import { render, staticRenderFns } from "./OrdersDetails.vue?vue&type=template&id=215c99bf"
import script from "./OrdersDetails.vue?vue&type=script&lang=js"
export * from "./OrdersDetails.vue?vue&type=script&lang=js"
import style0 from "./OrdersDetails.vue?vue&type=style&index=0&id=215c99bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports